import { CorporateAccountOpenProfileDetailsPages, useCorporateAccountOpenProfileDetailsPageTypeStore } from 'views/pages/accountOpenProfileDetails/corporateProfileDetails/hooks';
import { useState } from 'react';
import { useCorporateAccountEstablishStore } from '../hooks';
import { TemplateProps } from '../common';
import { InvestorCategory } from 'views/utils/enums';

export type SelectGeneralInvestorType = {
  dealerQuestion: boolean | null;
  identificationQuestion: boolean | null
  selfieQuestion: boolean | null;
  personalInformation: boolean;
  generalTermsCondition: boolean;
};

export const useSelectGeneralInvestor = ({ isUpdate, setPageStep }: TemplateProps) => {
  const [isLinkClicked, setIsLinkClicked] = useState(false);
  const { setAccountOpenProfileDetailsPageType, setPreviousPage } = useCorporateAccountOpenProfileDetailsPageTypeStore();
  const { param, add } = useCorporateAccountEstablishStore();

  const setMigrationPreference = (isMigrationDesired : boolean)=>{
    if(isMigrationDesired){
      setAccountOpenProfileDetailsPageType(CorporateAccountOpenProfileDetailsPages.offerConfirm)  
    }
    else{
      setAccountOpenProfileDetailsPageType(CorporateAccountOpenProfileDetailsPages.specialInvestorConfirm)
      setPreviousPage(CorporateAccountOpenProfileDetailsPages.selectGeneralInvestor)
      add({
        ...param,
        ...{
          investorCategory: InvestorCategory.SpecificInvestor,
          consentDate : '',
        },
      });
    }
  }

  return {
    isLinkClicked,
    setIsLinkClicked,
    setMigrationPreference
  };
};
